<template>
  <div class="avatar-preview" :style="`width: ${size}; height: ${size};`">
    <img v-if="avatar !== null && avatar.file_size" :src="avatar.url" alt="Фото сотрудника">
    <img v-else src="/img/svg/avatar__icon.svg" alt="Фото отсутствует">
  </div>
</template>

<script>
export default {
  name: 'app-avatar-preview',
  props: {
    avatar: {
      type: Object || null,
      default: null
    },
    size: {
      type: String,
      default: '100px'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.avatar-preview {
  border-radius: 50%;
  overflow: hidden;
  background-color: $color__forest-wolf;

  img {
    object-fit: cover;
    width: 100%;
    height: auto;
    min-height: 100%;
  }
}
</style>
